module.exports = __webpack_public_path__ + "img/ไข่ปลาคาร์เวียร์.5fb14c5d.jpg";